import Cookies from "js-cookie";
import API_BASE_URL from "../config";

let refreshPromise = null;
let failedQueue = [];

/**
 * Iterates through blocked pending API requests once refresh has concluded.
 */
function processQueue(error, token = null) {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
}

/**
 * Dedicated secure background rotation execution block.
 * Uses native fetch and 'include' credentials to seamlessly pipe HttpOnly cookies.
 */
async function refreshAccessToken() {
  if (refreshPromise) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    });
  }

  // Target the rotated secure endpoint we wired up in api/auth.py
  refreshPromise = fetch(`${API_BASE_URL}/api/v1/auth/refresh`, {
    method: "POST",
    headers: {
      "X-CSRF-Token": Cookies.get("csrf") || "",
      "Content-Type": "application/json"
    },
    credentials: "include", 
  })
    .then(async (res) => {
      if (!res.ok) {
        const err = new Error("Session expansion failed.");
        err.status = res.status;
        throw err;
      }
      return res.json();
    })
    .then((data) => {
      processQueue(null, null);
      return null;
    })
    .catch((err) => {
      processQueue(err);
      throw err;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}

/**
 * Core CHITRA secure fetch interceptor client wrapper.
 */
export async function chitraFetch(endpoint, options = {}) {
  const url = endpoint.startsWith("http") ? endpoint : `${API_BASE_URL}${endpoint}`;
  
  options.headers = options.headers || {};
  options.credentials = "include"; 

  // --- REQUEST INTERCEPTOR: Inject State Protection ---
  const csrfToken = Cookies.get("csrf");
  if (csrfToken) {
    options.headers["X-CSRF-Token"] = csrfToken;
  }

  if (!(options.body instanceof FormData)) {
    options.headers["Content-Type"] = "application/json";
  }

  let response = await fetch(url, options);

  // --- RESPONSE INTERCEPTOR: Catch Expiry and Replay ---
  if (response.status === 401 && !options._retry) {
    options._retry = true;

    try {
      await refreshAccessToken();
      
      const rotatedCsrf = Cookies.get("csrf");
      if (rotatedCsrf) {
        options.headers["X-CSRF-Token"] = rotatedCsrf;
      }

      response = await fetch(url, options);
    } catch (refreshError) {
      localStorage.removeItem("chitra_user");
      window.location.href = "/";
      return Promise.reject(refreshError);
    }
  }

  return response;
}